import { z } from "zod";
// `Exhibitor` (root ADR-036) is a stand's account on an event: it starts
// rooms and reads its own conversations, and nothing else of the team's.
// It is made from the Rooms tab, never through "Add a team member", so the
// roles an organiser may hand out are the first three.
export const TEAM_MEMBER_ROLE_ENUM = ["Owner", "Admin", "Member", "Exhibitor"];
export const teamMemberRoleZod = z.enum(TEAM_MEMBER_ROLE_ENUM);
export const ASSIGNABLE_TEAM_MEMBER_ROLE_ENUM = ["Owner", "Admin", "Member"];
export const assignableTeamMemberRoleZod = z.enum(ASSIGNABLE_TEAM_MEMBER_ROLE_ENUM);
export const THEME_SETTING_ENUM = ["dark", "light", "system"];
export const themeSettingZod = z.enum(THEME_SETTING_ENUM);
export const WEBHOOK_STATUS_ENUM = ["Pending", "Sent", "Failed"];
export const webhookStatusZod = z.enum(WEBHOOK_STATUS_ENUM);
export const PG_TBUS_TASK_STATUS_ENUM = ["pending", "active", "completed", "failed", "cancelled"];
export const pgTbusTaskStatusZod = z.enum(PG_TBUS_TASK_STATUS_ENUM);
// Minutes ledger — every row moves a team's balance of purchased live
// minutes. `grant` = super-admin credit (purchase), `adjustment` = manual
// correction (either sign), `usage` = consumption by a live session (later).
export const MINUTE_LEDGER_KIND_ENUM = ["grant", "adjustment", "usage"];
export const minuteLedgerKindZod = z.enum(MINUTE_LEDGER_KIND_ENUM);
// What a `usage` row paid for (root ADR-037): a stage session at the desk,
// or a room at a stand. One pool of minutes, told apart for billing.
export const LEDGER_PRODUCT_ENUM = ["stage", "room"];
export const ledgerProductZod = z.enum(LEDGER_PRODUCT_ENUM);
export const FEATURE_FLAG_SCOPE_ENUM = ["global", "team"];
export const featureFlagScopeZod = z.enum(FEATURE_FLAG_SCOPE_ENUM);
// Device platform reported by the frontend at push-register time.
// Broad enough to cover every OS a Web Push subscription can originate
// from, with `other` as a catchall so unknown UAs don't fail validation.
// Extend as new platforms show up (visionos, harmonyos, fireos, etc.).
export const DEVICE_PLATFORM_ENUM = [
    "ios",
    "android",
    "macos",
    "windows",
    "linux",
    "chromeos",
    "other",
];
export const devicePlatformZod = z.enum(DEVICE_PLATFORM_ENUM);
// Why a push_devices row was soft-deleted. Separates voluntary churn
// (user toggled off / logged out) from involuntary (upstream pruned).
// Extend as new detachment paths land (e.g. "browser_rotated" when we
// handle pushsubscriptionchange server-side).
export const DEVICE_DEACTIVATION_REASON_ENUM = [
    "user_revoked",
    "novu_pruned",
    "subscriber_deleted",
];
export const deviceDeactivationReasonZod = z.enum(DEVICE_DEACTIVATION_REASON_ENUM);
//# sourceMappingURL=enums.zod.js.map